import _ from 'lodash';

export const formatNamespace = (namespace: string) =>
  _.startCase(namespace)
    .replaceAll('Corelogic', 'CoreLogic')
    .replaceAll('Clapi', 'CLAPI')
    .replaceAll('Api', 'API')
    .replaceAll('Psx', 'PSX')
    .replaceAll('Default', 'N/A');
